import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { networkRequest } from '@tencent/ark-request';
import { getXsrfToken } from "../cgi/cookies";
export function getDownloadUrl(_x) {
  return _getDownloadUrl.apply(this, arguments);
}
function _getDownloadUrl() {
  _getDownloadUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(req) {
    var resp;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return networkRequest.request({
            url: "/v2/drive/downloadURL?xsrf=".concat(getXsrfToken()),
            method: 'POST',
            headers: req.headers,
            data: _objectSpread({
              file_id: req.fileId,
              obj_key: req.objKey
            }, req.download_context && {
              download_context: req.download_context
            })
          });
        case 2:
          resp = _context.sent;
          return _context.abrupt("return", resp.data);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getDownloadUrl.apply(this, arguments);
}
//# sourceMappingURL=download-url.js.map